import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { useDropdownMenu } from '@restart/ui/DropdownMenu';
import useIsomorphicEffect from '@restart/hooks/useIsomorphicEffect';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import warning from 'warning';
import DropdownContext from './DropdownContext';
import InputGroupContext from './InputGroupContext';
import NavbarContext from './NavbarContext';
import { useBootstrapPrefix } from './ThemeProvider';
import useWrappedRefWithWarning from './useWrappedRefWithWarning';
import { alignPropType } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultProps = {
  flip: true
};
export function getDropdownMenuPlacement(alignEnd, dropDirection, isRTL) {
  var topStart = isRTL ? 'top-end' : 'top-start';
  var topEnd = isRTL ? 'top-start' : 'top-end';
  var bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
  var bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
  var leftStart = isRTL ? 'right-start' : 'left-start';
  var leftEnd = isRTL ? 'right-end' : 'left-end';
  var rightStart = isRTL ? 'left-start' : 'right-start';
  var rightEnd = isRTL ? 'left-end' : 'right-end';
  var placement = alignEnd ? bottomEnd : bottomStart;
  if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
  return placement;
}
var DropdownMenu = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    align = _ref.align,
    rootCloseEvent = _ref.rootCloseEvent,
    flip = _ref.flip,
    showProps = _ref.show,
    renderOnMount = _ref.renderOnMount,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    popperConfig = _ref.popperConfig,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "align", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig", "variant"]);
  var alignEnd = false;
  var isNavbar = useContext(NavbarContext);
  var prefix = useBootstrapPrefix(bsPrefix, 'dropdown-menu');
  var _useContext = useContext(DropdownContext),
    contextAlign = _useContext.align,
    drop = _useContext.drop,
    isRTL = _useContext.isRTL;
  align = align || contextAlign;
  var isInputGroup = useContext(InputGroupContext);
  var alignClasses = [];
  if (align) {
    if (typeof align === 'object') {
      var keys = Object.keys(align);
      process.env.NODE_ENV !== "production" ? warning(keys.length === 1, 'There should only be 1 breakpoint when passing an object to `align`') : void 0;
      if (keys.length) {
        var brkPoint = keys[0];
        var direction = align[brkPoint]; // .dropdown-menu-end is required for responsively aligning
        // left in addition to align left classes.

        alignEnd = direction === 'start';
        alignClasses.push("".concat(prefix, "-").concat(brkPoint, "-").concat(direction));
      }
    } else if (align === 'end') {
      alignEnd = true;
    }
  }
  var placement = getDropdownMenuPlacement(alignEnd, drop, isRTL);
  var _useDropdownMenu = useDropdownMenu({
      flip: flip,
      rootCloseEvent: rootCloseEvent,
      show: showProps,
      usePopper: !isNavbar && alignClasses.length === 0,
      offset: [0, 2],
      popperConfig: popperConfig,
      placement: placement
    }),
    _useDropdownMenu2 = _slicedToArray(_useDropdownMenu, 2),
    menuProps = _useDropdownMenu2[0],
    _useDropdownMenu2$ = _useDropdownMenu2[1],
    hasShown = _useDropdownMenu2$.hasShown,
    popper = _useDropdownMenu2$.popper,
    show = _useDropdownMenu2$.show,
    toggle = _useDropdownMenu2$.toggle;
  menuProps.ref = useMergedRefs(useWrappedRefWithWarning(ref, 'DropdownMenu'), menuProps.ref);
  useIsomorphicEffect(function () {
    // Popper's initial position for the menu is incorrect when
    // renderOnMount=true. Need to call update() to correct it.
    if (show) popper == null ? void 0 : popper.update();
  }, [show]);
  if (!hasShown && !renderOnMount && !isInputGroup) return null; // For custom components provide additional, non-DOM, props;

  if (typeof Component !== 'string') {
    menuProps.show = show;
    menuProps.close = function () {
      return toggle == null ? void 0 : toggle(false);
    };
    menuProps.align = align;
  }
  var style = props.style;
  if (popper != null && popper.placement) {
    // we don't need the default popper style,
    // menus are display: none when not shown.
    style = _objectSpread({}, props.style, menuProps.style);
    props['x-placement'] = popper.placement;
  }
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, menuProps, {
    style: style // Bootstrap css requires this data attrib to style responsive menus.
  }, (alignClasses.length || isNavbar) && {
    'data-bs-popper': 'static'
  }, {
    className: classNames.apply(void 0, [className, prefix, show && 'show', alignEnd && "".concat(prefix, "-end"), variant && "".concat(prefix, "-").concat(variant)].concat(alignClasses))
  }));
});
DropdownMenu.displayName = 'DropdownMenu';
DropdownMenu.defaultProps = defaultProps;
export default DropdownMenu;